// FreeHub shell locale catalogue — English (default and fallback).
//
// Значение ключа: строка либо объект plural-форм CLDR (`one`/`few`/`many`/`other`).
// Плейсхолдеры `{name}` должны совпадать в en.js и ru.js (проверяет locale gate).
// Набор ключей обязан совпадать с ru.js; обязательный список — в scripts/check-locales.js.

export default Object.freeze({
  // --- login / owner bootstrap ---------------------------------------------
  "login.bootstrap.heading": "Create owner",
  "login.bootstrap.sub": "Document management and semantic search",
  "login.bootstrap.note":
    "Create the single owner account. Then sign in with the chosen credentials.",
  "login.bootstrap.submit": "Create owner",
  "login.bootstrap.busy": "Creating…",
  "login.heading": "Sign in",
  "login.sub": "Document management and semantic search",
  "login.note": "Sign in with your username and password.",
  "login.submit": "Sign in",
  "login.busy": "Signing in…",
  "login.username": "Username",
  "login.password": "Password",
  "login.passwordConfirmation": "Confirm password",
  "login.version": "FreeHub community",
  "login.locale.label": "Interface language",

  // --- shell chrome --------------------------------------------------------
  "shell.nav.documents": "Documents",
  "shell.nav.agents": "Agents",
  "shell.nav.evaluation": "Quality evaluation",
  "shell.nav.logs": "Logs",
  "shell.nav.system": "System",
  "shell.nav.openMenu": "Open menu",
  "shell.nav.skipToMain": "Skip to main content",
  "shell.ws.copy": "Copy namespace",
  "shell.ws.copySuccess": "Copied: {name}",
  "shell.ws.copyError": "Copy failed",
  "shell.account.logoutTitle": "Sign out: {username}",
  "shell.action.newDocument": "New document",
  "shell.action.newAgent": "New agent",
  "shell.locale.label": "Interface language",
  "shell.title.documents": "Documents",
  "shell.title.agents": "Agents",
  "shell.title.evaluation": "Quality evaluation",
  "shell.title.logs": "Logs",
  "shell.title.system": "System",
  "shell.subtitle.documents": "Upload, processing and document management",
  "shell.subtitle.agents": "Linking agents to knowledge bases.",
  "shell.subtitle.evaluation": "Search and answer quality.",
  "shell.subtitle.logs": "Execution traces and system events.",
  "shell.subtitle.system": "Administrator sessions and the owner password.",

  // --- System panel (Story 1.6) -------------------------------------------
  "system.sessions.title": "Ending sessions",
  "system.sessions.descriptionLead":
    "The avatar button ends only the current session. The action below ends ",
  "system.sessions.descriptionStrong": "all",
  "system.sessions.descriptionTail":
    " installation administrator sessions, including this one.",
  "system.sessions.submit": "End all sessions",
  "system.sessions.confirmQuestion":
    "End all sessions, including this one? You will need to sign in again.",
  "system.sessions.busy": "Ending…",
  "system.sessions.confirm": "Confirm",
  "system.sessions.cancel": "Cancel",
  "system.password.title": "Owner password",
  "system.password.description":
    "Changing the password immediately invalidates the old password and ends all " +
    "administrator sessions. The new password confirmation is used only here and is " +
    "never sent to the server.",
  "system.password.open": "Change password",
  "system.password.current": "Current password",
  "system.password.new": "New password",
  "system.password.confirmation": "Confirm new password",
  "system.password.submit": "Change password",
  "system.password.busy": "Changing…",
  "system.password.cancel": "Cancel",

  // --- shared notices ------------------------------------------------------
  "notice.sessionEnded":
    "All sessions ended. Sign in again — the previous sessions are no longer valid.",
  "notice.passwordChanged": "Password changed, all sessions ended. Sign in with the new password.",
  "notice.logoutUnconfirmed":
    "The server did not confirm sign-out. The session may stay active until it expires — " +
    "try signing out again.",
  "notice.sessionExpired":
    "The administrator session expired. Sign in again: uploaded files and unfinished forms " +
    "will need to be provided again.",
  "notice.bootstrapAlreadyComplete":
    "Setup is already complete. Sign in with the owner credentials.",
  "notice.bootstrapNotConfirmed":
    "The server did not confirm that setup is complete. Try signing in later.",
  "notice.bootstrapOwnerCreated":
    "The owner was created. Now sign in with the chosen credentials.",
  // Story 1.8: fallback-навигация к списку вместо отсутствующего документа.
  "notice.documentMissing":
    "This document is no longer available: it was deleted or was not found. " +
    "The document list is shown instead.",
  // Story 1.8: недоступный список не выдаётся за удалённый документ.
  "error.route.documentsUnavailable":
    "The FreeHub server is temporarily unavailable: the document list could not be " +
    "loaded. Try again later.",
  // Story 1.14: create-вход закрыт, пока готовность системы не подтверждена.
  "notice.readinessUnavailable":
    "System readiness is not confirmed, so document creation is unavailable. " +
    "Check the service state and use “Check again”.",
  "error.upload.notReady":
    "Upload is unavailable: required services are not confirmed ready. " +
    "Check the system state and try again.",

  // --- login/bootstrap/session errors (safe semantic codes) ----------------
  "error.auth_unavailable": "The FreeHub server is temporarily unavailable",
  "error.auth_invalid_response": "The FreeHub server returned an invalid response",
  "error.auth_session_unavailable": "Could not verify the session",
  "error.auth_session_timeout": "The session check did not respond in time",
  "error.auth_bootstrap_check_failed": "Could not check the setup state",
  "error.auth_bootstrap_check_unavailable": "Could not confirm the setup state",
  "error.auth_bootstrap_unavailable":
    "The FreeHub server is temporarily unavailable. Initial setup is closed.",
  "error.auth_bootstrap_status_invalid":
    "The FreeHub server returned an invalid initial setup status",
  "error.auth_bootstrap_response_invalid": "Could not process the server response",
  "error.auth_bootstrap_request_invalid":
    "Check the username and password: the server rejected the submitted data.",
  "error.auth_owner_unavailable":
    "The FreeHub server is temporarily unavailable. The owner was not created; try again later.",
  "error.auth_owner_create_failed": "Could not create the owner. Try again later.",
  "error.auth_invalid_credentials": "Invalid username or password",
  "error.auth_rate_limited": "Too many failed sign-in attempts. Try again later.",
  "error.auth_session_create_failed": "Could not create a session",
  "error.auth_login_failed": "Could not sign in",
  "error.auth_request_oversized": "The request size exceeds the allowed limit",

  // --- System command refusals (Story 1.6 semantics, semantic keys) --------
  "error.command.invalid_credentials":
    "The current password is incorrect. Fix the value and try again.",
  "error.command.password_unchanged":
    "The new password matches the current one. Choose another password.",
  "error.command.password_policy_violation":
    "The new password does not meet the requirements: choose a longer, less obvious one.",
  "error.command.invalid_password_change_request":
    "The server rejected the password change request: check the filled fields.",
  "error.command.invalid_session_command_request":
    "The server does not accept parameters for this action. Retry without data.",
  "error.command.unsupported_media_type":
    "The server rejected the request format. Reload the page and try again.",
  "error.command.csrf_rejected":
    "Cross-site request protection rejected the action. Reload the page and try again.",
  "error.command.auth_overload": "The server is overloaded with password checks. Wait and try again.",
  "error.command.unavailable": "The FreeHub server is temporarily unavailable. Try the action again.",
  "error.command.unknown_commit":
    "The server did not confirm the result: the change may or may not have been applied. " +
    "Sign in again and check the state — automatically repeating the command is unsafe.",
  "error.command.unconfirmed":
    "The server did not confirm that the action completed: the response does not match the " +
    "contract, so the change may or may not have been applied. Sign in again and check the " +
    "state — automatically repeating the command is unsafe.",
  "error.command.aborted":
    "The server did not confirm the result: the change may or may not have been applied. " +
    "Sign in again and check the state — automatically repeating the command is unsafe.",
  "error.command.authentication_required": "The session has expired — sign in again.",
  "error.command.generic": "The action could not be completed. Try the action again.",
  "error.password.mismatch": "The new passwords do not match.",
  "error.bootstrap_password.mismatch": "The passwords do not match",
  "error.model.unavailable": "The settings state could not be loaded. Try again later.",

  // --- Story 1.10: model settings and read-only storage diagnostics --------
  "system.model.title": "Model connection",
  "system.model.description":
    "Test an Ollama-compatible model before saving. Saving does not activate the RAG profile or reindex documents.",
  "system.model.provider": "Connection type",
  "system.model.local": "Local model",
  "system.model.remote": "Remote model",
  "system.model.baseUrl": "Base URL",
  "system.model.model": "Model",
  "system.model.dimension": "Declared dimension",
  "system.model.credential": "Credential (write-only)",
  "system.model.credentialPresent": "A credential is stored; its value is never shown.",
  "system.model.credentialAbsent": "No credential is configured.",
  "system.model.test": "Test connection",
  "system.model.testing": "Testing...",
  "system.model.save": "Save settings",
  "system.model.saving": "Saving...",
  "system.model.idle": "No connection test has run yet.",
  "system.model.resultOk": "Connection verified: {model}, dimension {dimension}.",
  "system.model.resultFailed": "Connection test failed: {reason}.",
  "system.model.testRequired": "Run a successful connection test first.",
  "system.model.saved": "Settings saved. The active RAG profile was not changed.",
  "system.model.storageHint": "The model settings path is configured in .env; storage endpoints are not edited here.",
  "system.storage.title": "Storage diagnostics",
  "system.storage.description":
    "Read-only: the readiness contract reports configured dependencies. Storage endpoints and data migration are handled outside this panel.",
  "system.storage.ready": "Every configured component is ready.",
  "system.storage.notReady": "Some components are not ready.",
  "system.storage.unknown": "State was not received.",
  "system.storage.status.ready": "ready",
  "system.storage.status.notReady": "not ready",
  "system.storage.component.postgres": "PostgreSQL",
  "system.storage.component.qdrant": "Qdrant",
  "system.storage.component.age": "Apache AGE (PostgreSQL)",
  "system.storage.component.memgraph": "Memgraph (legacy external store)",
  "system.storage.component.graph": "Graph store",
  "system.storage.component.s3": "S3 object store",
  "system.storage.reason.graph_backend_unsupported":
    "The configured graph backend is not supported.",
  "system.storage.reason.graph_backend_incompatible":
    "The graph backend is installed, but its version or schema is incompatible.",
  "system.storage.reason.configuration_missing": "Required storage settings are missing.",
  "system.storage.reason.authentication_failed":
    "The storage rejected the configured credentials.",
  "system.storage.reason.connection_failed": "The storage could not be reached.",
  "system.storage.reason.dependency_error": "A dependency of the storage check failed.",
  "system.storage.reason.timeout": "The storage check did not finish in time.",
  "system.storage.reason.unknown": "The storage check reported an unclassified problem.",
  // --- Story 1.14: safe next actions and landing system status --------------
  "system.storage.action.check_configuration": "Check the storage settings.",
  "system.storage.action.check_credentials": "Check the storage credentials.",
  "system.storage.action.check_connection": "Check the network connection to the storage.",
  "system.storage.action.check_component": "Check the storage component itself.",
  "system.storage.action.retry_check": "Retry the check later.",
  "system.storage.action.unknown": "Retry the check and read the logs.",
  "overview.status.title": "System status",
  "overview.status.process.available": "API process: available",
  "overview.status.process.unavailable": "API process: unavailable",
  "overview.status.process.unknown": "API process: state not confirmed",
  "overview.status.dependencies.ready": "Required services are ready",
  "overview.status.dependencies.notReady": "Required services are not ready",
  "overview.status.dependencies.unknown": "Service state is not confirmed",
  "overview.status.dependencies.stale": "Service readiness is stale",
  "overview.status.stale": "This data is stale — use “Check again”.",
  "overview.status.refresh": "Check again",
  "system.model.reason.invalid_base_url": "invalid URL — an http/https origin without query is required",
  "system.model.reason.invalid_model": "invalid model name",
  "system.model.reason.invalid_dimension": "dimension must be between 1 and 65536",
  "system.model.reason.invalid_credential": "invalid credential value",
  "system.model.reason.timeout": "the request timed out",
  "system.model.reason.unsupported_model": "the service does not support this model",
  "system.model.reason.connection_failed": "the service could not be reached",
  "system.model.reason.dependency_error": "the service returned an error",
  "system.model.reason.response_too_large": "the service response is too large",
  "system.model.reason.invalid_response": "the service response is invalid",
  "system.model.reason.count_mismatch": "the service returned the wrong number of vectors",
  "system.model.reason.dimension_mismatch": "the actual dimension did not match the declared one",
  "system.model.reason.non_finite": "a vector contains non-finite values",
  "system.model.reason.zero_vector": "a vector is all zeros",
  "system.model.reason.model_mismatch": "the service reported a different model than requested",
  "system.model.reason.successful_connection_test_required": "run a successful connection test first",
  "system.model.reason.draft_changed_after_test": "the settings changed after the test — test again",
  "system.model.reason.revision_mismatch": "the settings already changed — load the current state",
  "system.model.reason.probe_revision_mismatch": "the test belongs to an older settings revision",
  "system.model.reason.model_settings_storage_unavailable": "settings storage is unavailable",
  "system.model.reason.model_probe_concurrency_exhausted": "too many concurrent connection tests",
  "system.model.reason.request_too_large": "the request is too large",
  "system.model.reason.invalid_request_body": "the request is invalid",
  "system.model.reason.authentication_required": "the session expired — sign in again",
  "system.model.reason.unknown": "unknown reason",

  // --- shell formatting ----------------------------------------------------
  "format.bytes.empty": "0 B",
  "format.bytes.unit.b": "B",
  "format.bytes.unit.kb": "KB",
  "format.bytes.unit.mb": "MB",
  "format.date.none": "no date",
});
